import { GrapevineAppApi } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useMemo } from 'react';

import { useApiConfiguration } from '@/features/api/hooks/useApiConfiguration';

export const useGrapevineAppApi = () => {
  const configuration = useApiConfiguration();
  return useMemo(() => new GrapevineAppApi(configuration), [configuration]);
};
